export default {
    label: 'コピー',
    successMessage: 'コピーされました。',
};
